'use strict';

/* jshint esversion: 6 */
/* jshint -W051 */
(function ($) {

	// Top Notification Block Carousel
	var notificationBarCarousel, notificationBarOptions;

	notificationBarCarousel = $('.c-notification-block .owl-carousel');

	notificationBarOptions = {
		loop: true,
		nav: false,
		autoHeight: false,
		dots: false,
		margin: 0,
		responsive: {
			0: {
				items: 1
			}
		},
		onInitialized: function removeRolePresentationFromButtons() {
			$('.c-notification-block .owl-carousel .owl-nav button').removeAttr('role');
		}
	};

	if (notificationBarCarousel.length) {
		notificationBarCarousel.owlCarousel(notificationBarOptions);
		//$('.page-header').addClass('has-notify-banner');
	}

	var notifyBarNext = $('.notification-bar-nav .next');
	var notifyBarPrev = $('.notification-bar-nav .prev');

	notifyBarNext.on('click', function () {
		notificationBarCarousel.trigger('next.owl.carousel');
		return false;
	});

	notifyBarPrev.on('click', function () {
		notificationBarCarousel.trigger('prev.owl.carousel');
		return false;
	});

	// Hero Carousel
	var heroExists = $('.hero');

	var loopStatus, dragStatus, heroSlides;
	heroSlides = $('.slide', heroExists).length;

	if (heroSlides === 1) {
		loopStatus = false;
		dragStatus = false;
	} else {
		loopStatus = true;
		dragStatus = true;
	}

	// get the value of the dir attribute on the html element (set to rtl when arabic language is enabled)
	var textDir, rtl;
	textDir = document.documentElement.getAttribute('dir');

	if (textDir === 'rtl') {
		rtl = true;
	} else {
		rtl = false;
	}

	var heroCarousel = $('.owl-carousel', heroExists);
	var heroNext = $('.hero-nav .next', heroExists);
	var heroPrev = $('.hero-nav .prev', heroExists);

	if (heroCarousel.length) {
		heroCarousel.owlCarousel({
			items: 1,
			lazyLoad: true,
			autoPlay: false,
			loop: loopStatus,
			dots: false,
			draggable: dragStatus,
			mouseDrag: dragStatus,
			rtl: rtl,
			touchDrag: dragStatus,

			onInitialized: function onInitialized() {
				if ($(".owl-item.active video", this.$element).length) {
					$(".owl-item.active video", this.$element)[0].play();
					heroCarousel.trigger('stop.owl.autoplay');
					//     $(".owl-item.active video", this.$element).on('ended', function() {
					//         heroCarousel.trigger('play.owl.autoplay');
					//     });
				}
				$('.hero .owl-carousel .owl-nav button').removeAttr('role');
			}
		});
	}

	$(window).on('load', function () {
		if (window.innerWidth < 768) {
			// on mobile, get closer to the actual viewport (ios viewport includes some of Safari's chrome, so 100vh looks weird)
			// heroCarousel.find('.slide').height(window.innerHeight);
		}
	});

	function singlePlay() {
		var heroVideo = document.querySelector('.owl-item.active video');

		// check for the loop attribute, which is set via the hero slide paragraph
		if (heroVideo && !heroVideo.hasAttribute('loop')) {
			heroVideo.addEventListener('ended', function () {
				// this assumes that the video to only play once is the first slide, and the slide to jump to follows it in the sequence.
				// was using next.owl.carousel, but that was buggy and would send you to the last slide if you were going through
				// the carousel a second (or subsequent) time.
				heroCarousel.trigger('to.owl.carousel', 1);
			}, true);
		}

		// when the slide changes, check to see if there's a video in it, and if there is, start it playing, while disabling owl's autoplay.
		// then run singlePlay again to see if it's another single loop video. If the slide doesn't contain a video, we carry on as normal.
		heroCarousel.on('changed.owl.carousel', function (e) {
			setTimeout(function () {
				if (document.querySelector('.owl-item.active video')) {
					var _heroVideo = document.querySelector('.owl-item.active video');
					_heroVideo.play();
					heroCarousel.trigger('stop.owl.autoplay');
				}
				singlePlay();
			}, 1);
		});
	}
	singlePlay();

	heroNext.on('click', function () {
		heroCarousel.trigger('next.owl.carousel');
		return false;
	});

	heroPrev.on('click', function () {
		heroCarousel.trigger('prev.owl.carousel');
		return false;
	});

	// Offers Carousel
	var offersExists = $('.offers');
	var numCards, shouldLoop;

	if (offersExists.length) {
		numCards = $(offersExists).find('.offer');
		shouldLoop = numCards.length > 2;
		$('.owl-carousel', offersExists).owlCarousel({
			dots: false,
			lazyLoad: true,
			dotsData: '<span>Carousel Item</span>',
			rtl: rtl,
			loop: shouldLoop,
			nav: shouldLoop,
			mouseDrag: shouldLoop,
			responsive: {
				0: {
					items: 1
				},
				768: {
					items: 2,
					margin: 20
				},
				1024: {
					margin: 40,
					items: 2,
					stagePadding: 100
				},
				1440: {
					margin: 40,
					items: 2,
					stagePadding: 200
				}
			},
			// fixes bug with owl-nav disabling itself if viewable items are less than/equal to items
			onInitialized: function onInitialized(e) {
				var $this = $(e.currentTarget);
				if (shouldLoop) {
					$this.find('.owl-nav').removeClass('disabled');
				}

				var sliderButtonsArray = $('.offers .owl-nav button');
				sliderButtonsArray.each(function () {
					$(this).removeAttr("role");
				});
				// This is to keep the styling of the immediate previous sibling of an active owl item visible 
				var firstActiveOwl = $('.offers .owl-stage .owl-item.active:first');
				firstActiveOwl.prev().find('img').css("visibility", "visible");
			},
			onChanged: function onChanged(e) {
				var $this = $(e.currentTarget);
				if (shouldLoop) {
					$this.find('.owl-nav').removeClass('disabled');
				}
			},
			onTranslated: function onTranslated(e) {
				// This is to keep the styling of the immediate previous sibling of an active owl item visible 
				var firstActiveOwl = $('.offers .owl-stage .owl-item.active:first');
				firstActiveOwl.prev().find('img').css("visibility", "visible");
			}
		});
	}

	// Offers Carousel
	var galleryExists = $('.photo-gallery');

	if (galleryExists.length) {
		$('.owl-carousel', galleryExists).owlCarousel({
			dots: false,
			lazyLoad: true,
			dotsData: '<span>Carousel Item</span>',
			loop: true,
			rtl: rtl,
			nav: true,
			responsive: {
				0: {
					items: 1
				},
				768: {
					items: 1,
					margin: 20
				},
				1024: {
					margin: 40,
					items: 1
				},
				1440: {
					margin: 40,
					items: 1
				}
			}
		});
	}

	var amenityExists = $('.amenities');

	if (amenityExists.length) {
		$('.owl-carousel', amenityExists).owlCarousel({
			dots: false,
			autoHeight: false,
			loop: true,
			rtl: rtl,
			nav: true,
			center: true,
			responsive: {
				0: {
					items: 2
				},
				375: {
					items: 3
				},
				768: {
					items: 3
				},
				1024: {
					items: 5
				},
				1440: {
					items: 5,
					center: true
				}
			},
			onInitialized: function onInitialized() {
				$('.amenities .owl-nav button').removeAttr('role');
			}
		});
	}

	// Cards Carousels
	var cardCarousel, cardCarouselOpts;

	cardCarouselOpts = {
		loop: true,
		rtl: rtl,
		nav: true,
		autoHeight: false,
		dots: true,
		margin: 20,
		responsive: {
			0: {
				items: 1
			}
		}
	};

	cardCarousel = $('.cards .row.owl-carousel');

	$(window).on('load', function () {
		if (cardCarousel.length) {
			cardCarousel.owlCarousel(cardCarouselOpts);
		}
	});

	// News Carousel
	var newsSlide, newsCaption;

	newsSlide = $('.news-articles .images .owl-carousel').owlCarousel({
		nav: false,
		dots: false,
		dotsData: '<span>Carousel Item</span>',
		items: 1,
		draggable: false,
		loop: true,
		mouseDrag: false,
		touchDrag: true,
		animateOut: 'fadeOut',
		smartSpeed: 250,
		responsive: {
			768: {
				margin: 0,
				stagePadding: 0
			},
			1280: {
				margin: 0,
				stagePadding: 0
			},
			1440: {
				margin: 0,
				stagePadding: 0
			}
		}
	});

	newsCaption = $('.news-articles .captions .owl-carousel').owlCarousel({
		items: 1,
		loop: true,
		nav: true,
		// dotsData: '<span>Carousel Item</span>',
		dots: true,
		onInitialized: function onInitialized(event) {
			var sliderButtonsArray = $('.news-articles .owl-nav button');
			sliderButtonsArray.each(function () {
				$(this).removeAttr("role");
			});
			$('.field-guide .captions .owl-nav span').attr('role', 'button');
		},
		responsive: {
			1280: {
				width: 440
			}
		}
	});

	newsCaption.on('changed.owl.carousel', function (event) {
		if (event.namespace && event.property.name === 'position') {
			var target = event.relatedTarget.relative(event.property.value, true);
			newsSlide.owlCarousel('to', target, 300, true);
		}
	});

	newsSlide.on('changed.owl.carousel', function (event) {
		if (event.namespace && event.property.name === 'position') {
			var target = event.relatedTarget.relative(event.property.value, true);
			newsCaption.owlCarousel('to', target, 300, true);
		}
	});

	// When opening gallery modal, switch to the clicked slide
	$('.js-gallery-modal-link').click(function () {
		var $el = $(this),
		    targetSlide = $el.data('slide-to');

		$('#gallery-modal .owl-carousel').trigger('to.owl.carousel', [targetSlide, 500, true]);
	});

	//gallery keyboard trigger
	var owl = $("#gallery-modal .owl-carousel");
	jQuery(document).on('keydown', function (event) {
		if (event.which === 37) {
			owl.trigger('prev.owl');
		}
		if (event.which === 39) {
			owl.trigger('next.owl');
		}
	});

	// Event Carousel
	var eventsCarousel = $('section.events .owl-carousel');
	eventsCarousel.owlCarousel({
		items: 3,
		loop: true,
		nav: true,
		dots: false,
		margin: 20,
		responsive: {
			0: {
				items: 1
			},
			768: {
				items: 2
			},
			1024: {
				items: 3
			}
		}
	});
})(jQuery);

jQuery(document).ready(function ($) {

	initHotelRoomGallery();
	$('.owl-dots button').attr('tabindex', '-1');
});

function initHotelRoomGallery() {

	jQuery('.hotel-room.lead .hero-wrapper .owl-carousel').owlCarousel({
		items: 1,
		// lazyLoad:true,
		nav: true,
		loop: false,
		smartSpeed: 1000
	});

	jQuery('a[data-target="#gallery-modal"]').on('click', function () {
		jQuery("#gallery-modal .owl-carousel").owlCarousel({
			items: 1,
			// lazyLoad:true,
			nav: true,
			rewind: false,
			smartSpeed: 1000
		});
	});
}